import React from 'react';
import { Button } from '@fluentui/react-components';
import { EyeOffRegular, EyeRegular } from '@fluentui/react-icons';
import { useAppDispatch, useAppSelector } from '../../ducks/hooks';
import { toggleEarningsVisibility } from '../../ducks/earnings-visibility/duck-earnings-visibility';
import { useMEMTranslation } from '../../utils/text-utils';

export const ShowHideEarningsTab = () => {
  const { t } = useMEMTranslation();
  const dispatch = useAppDispatch();
  const areEarningsVisible = useAppSelector((state) => state.earningsVisibility.areEarningsVisible);

  const label = t(areEarningsVisible ? 'sellerExperienceHideEarnings' : 'sellerExperienceShowEarnings');

  return (
    <Button
      id="ToggleEarningsVisibilityButton"
      appearance="subtle"
      icon={areEarningsVisible ? <EyeRegular data-icon-name="earnings-visible" /> : <EyeOffRegular data-icon-name="earnings-hidden" />}
      onClick={() => dispatch(toggleEarningsVisibility())}
    >
      {label}
    </Button>
  );
};
